/* FranklyTho... storefront behaviour.
   Ported from the prototype logic in design/Store.dc.html (class Component) to vanilla JS on top of
   Shopify's AJAX Cart API, Section Rendering API, Predictive Search and Product Recommendations. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const S = Object.assign({ bundleNudge: true, bundleTypes: ['tee', 'kids'], ship: {} }, window.FT_SETTINGS || {});
  // Liquid's `t` filter HTML-escapes its output (e.g. ' becomes &#39;); decode once so textContent shows plain text.
  const decode = (s) => { const el = document.createElement('textarea'); el.innerHTML = s; return el.value; };
  const T = Object.fromEntries(Object.entries(window.FT_STRINGS || {}).map(([k, v]) => [k, typeof v === 'string' ? decode(v) : v]));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const withSection = (url, id) => { const u = new URL(url, location.origin); u.searchParams.set('section_id', id); return u.toString(); };

  /* ---------- Dialogs: focus trap, Esc, scroll lock ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const openStack = [];
  function openDialog(el, opener) {
    if (!el) return;
    el.hidden = false;
    el._opener = opener || document.activeElement;
    if (!openStack.includes(el)) openStack.push(el);
    document.documentElement.style.overflow = 'hidden';
    const target = $('[data-autofocus]', el) || $(FOCUSABLE, el);
    requestAnimationFrame(() => target && target.focus());
  }
  function closeDialog(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    const i = openStack.indexOf(el); if (i > -1) openStack.splice(i, 1);
    if (!openStack.length) document.documentElement.style.overflow = '';
    const o = el._opener; if (o && document.contains(o)) o.focus();
    if (el.id === 'ft-menu') $$('[data-action="open-menu"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  document.addEventListener('keydown', (e) => {
    const top = openStack[openStack.length - 1];
    if (e.key === 'Escape') {
      if (top) { closeDialog(top); return; }
      closeMega(); closeSearch(); closeQuickAdds();
      return;
    }
    if (e.key === 'Tab' && top) {
      const f = $$(FOCUSABLE, top).filter(x => x.offsetParent !== null || x === document.activeElement);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart ---------- */
  const cartEl = () => $('#ft-cart');
  const onCartPage = () => document.body.classList.contains('template-cart');
  function setCount(n) {
    $$('[data-cart-count]').forEach(c => { c.textContent = n; c.hidden = n < 1; });
    $$('[data-cart-link]').forEach(a => a.setAttribute('aria-label', (T.cartAria || 'Cart, {count} items').replace('{count}', n)));
  }
  async function refreshCart() {
    if (onCartPage()) { location.reload(); return; }
    const res = await fetch(`${ROOT}?sections=cart-drawer`);
    const data = await res.json();
    const doc = parse(data['cart-drawer']);
    const d = cartEl();
    if (d) {
      // Swap only the data-cart-region parts so the slide-in doesn't replay and the
      // express checkout buttons (initialised once by Shopify) stay mounted.
      const active = document.activeElement;
      const hadFocus = d.contains(active);
      const focusKey = hadFocus ? active.dataset.focusKey : null;
      $$('[data-cart-region]', d).forEach(r => { const n = $(`[data-cart-region="${r.dataset.cartRegion}"]`, doc); if (n) r.innerHTML = n.innerHTML; });
      const foot = $('[data-cart-foot]', d), nfoot = $('[data-cart-foot]', doc);
      if (foot && nfoot) foot.hidden = nfoot.hidden;
      if (hadFocus && !d.contains(document.activeElement)) {
        const back = focusKey && $(`[data-focus-key="${CSS.escape(focusKey)}"]`, d);
        (back || $('.ft-cart__close', d))?.focus();
      }
    }
    const countEl = $('[data-cart-total-count]', doc);
    if (countEl) setCount(+countEl.dataset.cartTotalCount);
  }
  function openCart(opener) { const d = cartEl(); if (!d) { location.href = `${ROOT}cart`; return; } openDialog(d, opener); }
  async function addToCart(variantId, qty = 1, btn) {
    if (!variantId) return;
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(`${ROOT}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +variantId, quantity: qty }] }) });
      if (!r.ok) { const e = await r.json().catch(() => ({})); alert(e.description || T.addError || 'Could not add. Frankly, tho, try again.'); return; }
      closeQuickAdds();
      const menu = $('#ft-menu'); if (menu && !menu.hidden) closeDialog(menu);
      await refreshCart();
      if (btn && btn.matches('[data-atc]') && $('[data-pdp][data-kids]') && burst(btn)) await new Promise(r => setTimeout(r, 450));
      openCart(btn);
    } finally { btn && btn.removeAttribute('aria-busy'); }
  }
  /* Kids tees: a small burst of brand dots from the add-to-cart button. */
  function burst(el) {
    if (reducedMotion || !el.animate) return false;
    const r = el.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
    for (let i = 0; i < 22; i++) {
      const d = document.createElement('span'); d.className = 'ft-burst';
      d.style.left = `${x}px`; d.style.top = `${y}px`;
      d.style.background = i % 3 ? 'var(--lime)' : 'var(--ink)';
      document.body.appendChild(d);
      const a = (Math.PI * 2 * i) / 22 + Math.random() * 0.4, dist = 70 + Math.random() * 90;
      const dx = Math.cos(a) * dist, dy = Math.sin(a) * dist - 40;
      d.animate([
        { transform: 'translate(-50%,-50%) scale(1) rotate(0deg)', opacity: 1 },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy + 90}px)) scale(.6) rotate(${Math.random() * 360}deg)`, opacity: 0 }
      ], { duration: 900 + Math.random() * 300, easing: 'cubic-bezier(.2,.7,.4,1)' }).onfinish = () => d.remove();
    }
    return true;
  }
  async function changeLine(key, quantity) {
    const inner = $('[data-cart-inner]'); inner && inner.setAttribute('aria-busy', 'true');
    await fetch(`${ROOT}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    await refreshCart();
    inner && inner.removeAttribute('aria-busy');
  }

  /* ---------- Header: mega menu, search, mobile menu ---------- */
  function closeMega() {
    $$('.ft-mega').forEach(m => m.hidden = true);
    $$('[data-mega]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  function showMega(btn) {
    closeSearch();
    $$('.ft-mega').forEach(m => m.hidden = m.id !== btn.dataset.mega);
    $$('[data-mega]').forEach(b => b.setAttribute('aria-expanded', String(b === btn)));
  }
  $$('[data-mega]').forEach(btn => {
    btn.addEventListener('mouseenter', () => showMega(btn));
    btn.addEventListener('focus', () => showMega(btn));
  });
  $('[data-header-wrap]')?.addEventListener('mouseleave', closeMega);
  document.addEventListener('focusin', (e) => { const w = $('[data-header-wrap]'); if (w && !w.contains(e.target)) { closeMega(); } });

  function closeSearch() {
    const s = $('#ft-search'); if (!s || s.hidden) return;
    s.hidden = true; $$('[data-action="toggle-search"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  function toggleSearch(btn) {
    const s = $('#ft-search'); if (!s) return;
    closeMega();
    s.hidden = !s.hidden;
    btn.setAttribute('aria-expanded', String(!s.hidden));
    if (!s.hidden) $('input[type="search"]', s).focus();
  }
  const sInput = $('#ft-search input[type="search"]');
  let sTimer, sCtrl;
  sInput?.addEventListener('input', () => {
    clearTimeout(sTimer);
    sTimer = setTimeout(async () => {
      const q = sInput.value.trim(); const out = $('#ft-search-results');
      if (!q) { out.innerHTML = ''; return; }
      sCtrl && sCtrl.abort(); sCtrl = new AbortController();
      try {
        const r = await fetch(`${ROOT}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,tag,variants.title&section_id=predictive-search`, { signal: sCtrl.signal });
        const doc = parse(await r.text());
        out.innerHTML = ($('[data-predictive]', doc) || doc.body).innerHTML;
      } catch (e) { /* aborted */ }
    }, 200);
  });

  /* ---------- Quick add on product cards ---------- */
  function closeQuickAdds(except) {
    $$('.ft-card__qa-panel').forEach(p => {
      if (p === except) return;
      p.hidden = true;
      const b = $('[data-action="qa-toggle"]', p.closest('.ft-card'));
      if (b) { b.textContent = '+'; b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', b.dataset.labelOpen); }
    });
  }
  document.addEventListener('mouseleave', (e) => {
    if (e.target instanceof Element && e.target.matches('.ft-card')) {
      const p = $('.ft-card__qa-panel', e.target); if (p && !p.hidden && !p.contains(document.activeElement)) closeQuickAdds();
    }
  }, true);

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-action]'); if (!t) return;
    const a = t.dataset.action;
    switch (a) {
      case 'open-cart': e.preventDefault(); openCart(t); break;
      case 'close-cart': e.preventDefault(); closeDialog(cartEl()); break;
      case 'qty': changeLine(t.dataset.key, +t.dataset.qty); break;
      case 'add': e.preventDefault(); addToCart(t.dataset.variant, 1, t); break;
      case 'open-menu': t.setAttribute('aria-expanded', 'true'); openDialog($('#ft-menu'), t); break;
      case 'close-menu': closeDialog($('#ft-menu')); break;
      case 'toggle-search': toggleSearch(t); break;
      case 'toggle-marquee': {
        const m = t.closest('.ft-marquee'); const p = m.classList.toggle('is-paused');
        t.textContent = p ? '\u25B6' : '\u275A\u275A';
        t.setAttribute('aria-label', p ? (T.marqueePlay || 'Play scrolling text') : (T.marqueePause || 'Pause scrolling text'));
        t.setAttribute('aria-pressed', String(p));
        break;
      }
      case 'qa-toggle': {
        e.preventDefault();
        const panel = $('.ft-card__qa-panel', t.closest('.ft-card'));
        const open = panel.hidden;
        closeQuickAdds(panel);
        panel.hidden = !open;
        t.textContent = open ? '\u00D7' : '+';
        t.setAttribute('aria-expanded', String(open));
        t.setAttribute('aria-label', open ? t.dataset.labelClose : t.dataset.labelOpen);
        if (open) $('button:not([disabled])', panel)?.focus();
        break;
      }
      case 'scroll-to': {
        e.preventDefault();
        const el = document.getElementById(t.dataset.target);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - 100, behavior: reducedMotion ? 'auto' : 'smooth' });
        break;
      }
      case 'close-dialog': closeDialog(t.closest('[data-dialog]')); break;
    }
  });

  /* ---------- Product card colour swatches: swap photo, link and quick-add colour ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.ft-swatch'); if (!sw) return;
    const card = sw.closest('.ft-card'); if (!card) return;
    const color = sw.dataset.cardColor;
    $$('.ft-swatch', card).forEach(b => b.setAttribute('aria-pressed', String(b === sw)));
    const img = $('.ft-card__media img:not(.is-second)', card);
    if (img && sw.dataset.src) { img.srcset = sw.dataset.srcset || ''; img.src = sw.dataset.src; card.classList.add('is-color-picked'); }
    if (sw.dataset.url) $$('.ft-card__link, .ft-card__title', card).forEach(a => { a.href = sw.dataset.url; });
    const single = $('.ft-card__qa[data-action="add"]', card);
    if (single && sw.dataset.variant) single.dataset.variant = sw.dataset.variant;
    const json = $('[data-card-variants]', card);
    if (json) {
      const rows = JSON.parse(json.textContent);
      $$('.ft-card__sizes .ft-size-chip', card).forEach(chip => {
        const row = rows.find(r => r[0] === color && r[1] === chip.dataset.size);
        const ok = !!(row && row[3]);
        chip.disabled = !ok;
        if (ok) { chip.dataset.action = 'add'; chip.dataset.variant = row[2]; chip.removeAttribute('aria-label'); }
        else { delete chip.dataset.action; chip.setAttribute('aria-label', `${chip.dataset.size}, ${T.soldOut || 'sold out'}`); }
      });
    }
  });

  /* ---------- Size chart units (cm / in), remembered per browser ---------- */
  function setUnit(unit) {
    $$('.ft-table--units').forEach(tb => tb.dataset.unit = unit);
    $$('[data-unit-btn]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.unitBtn === unit)));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-unit-btn]'); if (!b) return;
    setUnit(b.dataset.unitBtn);
    try { localStorage.setItem('ft_unit', b.dataset.unitBtn); } catch (_) { /* private mode */ }
  });
  try { const u = localStorage.getItem('ft_unit'); if (u === 'cm' || u === 'in') setUnit(u); } catch (_) { /* private mode */ }

  /* ---------- Localization selects submit on change ---------- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Accordions: one open at a time ---------- */
  function bindSingleAccordions(root = document) {
    $$('.ft-acc[data-single]', root).forEach(acc => $$('details', acc).forEach(d => d.addEventListener('toggle', () => {
      if (d.open) $$('details', acc).forEach(o => { if (o !== d) o.open = false; });
    })));
  }
  bindSingleAccordions();

  /* ---------- Customer forms (waitlist, newsletter, restock) without a page reload ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-ajax-form]'); if (!f || f.dataset.native) return;
    e.preventDefault();
    const btn = $('[type="submit"]', f); btn && btn.setAttribute('data-loading', '');
    try {
      const r = await fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } });
      // Shopify redirects to ?customer_posted=true / ?contact_posted=true on success. Anything else
      // (captcha challenge, validation errors) falls back to a normal submit so Shopify can render it.
      if (!r.ok || !/(customer|contact)_posted=true/.test(r.url)) { f.dataset.native = '1'; f.submit(); return; }
      const wrap = f.closest('[data-form-wrap]');
      if (wrap) { $$('[data-form-success]', wrap).forEach(s => s.hidden = false); f.hidden = true; }
    } catch (_) { f.dataset.native = '1'; f.submit(); }
    finally { btn && btn.removeAttribute('data-loading'); }
  });

  /* ---------- Discount code (cart drawer) ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-discount]'); if (!f) return;
    e.preventDefault();
    const code = f.elements.code.value.trim(); const msg = $('[data-discount-msg]', f);
    msg.hidden = false;
    if (!code) { msg.textContent = T.codeEmpty || 'Type a code first. Frankly, tho.'; return; }
    try {
      await fetch(`${ROOT}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
    } catch (_) { /* checkout re-validates the code anyway */ }
    const text = (T.codeSaved || 'Got it. We\'ll check "{code}" at checkout. If it\'s real, it\'s applied.').replace('{code}', code);
    await refreshCart();
    const m2 = $('[data-discount-msg]', cartEl() || document); if (m2) { m2.hidden = false; m2.textContent = text; }
  });

  /* ---------- Hero video respects reduced motion ---------- */
  if (reducedMotion) $$('[data-hero-video] video').forEach(v => { v.removeAttribute('autoplay'); v.pause(); });

  /* ---------- Delivery estimate (business days by country) ---------- */
  const EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');
  function shipRange(cc) {
    const r = S.ship || {};
    const pick = (v, d) => (String(v || d).match(/\d+/g) || d.match(/\d+/g)).map(Number);
    if (cc === 'US') return pick(r.us, '3-6');
    if (cc === 'GB' || EU.includes(cc)) return pick(r.ukeu, '5-8');
    if (cc === 'CA' || cc === 'AU') return pick(r.caau, '6-10');
    return pick(r.world, '7-14');
  }
  function addBusinessDays(n) {
    const d = new Date(); let k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w < 6) k++; }
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  $$('[data-eta]').forEach(el => {
    // Processing (before dispatch) + transit, both in business days.
    const [p1, p2] = (String((S.ship || {}).proc || '2-5').match(/\d+/g) || ['2', '5']).map(Number);
    const [a, b] = shipRange(el.dataset.eta);
    el.textContent = `${addBusinessDays(p1 + a)} \u2013 ${addBusinessDays((p2 || p1) + (b || a))}`;
  });

  /* ---------- Product page ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) initProduct(pdp);
  function initProduct(pdp) {
    const variants = JSON.parse($('[data-variants]', pdp).textContent);
    const ci = pdp.dataset.colorIndex === '' ? -1 : +pdp.dataset.colorIndex;
    const si = pdp.dataset.sizeIndex === '' ? -1 : +pdp.dataset.sizeIndex;
    const productAvailable = pdp.dataset.available === 'true';
    const single = si < 0 || $$('[data-option="size"] .ft-size', pdp).length < 2;
    const state = { color: null, size: null, other: {} };
    const idInput = $('[name="id"]', pdp);
    const atcBtns = $$('[data-atc]');
    const mainAtc = $('[data-atc-main]', pdp);
    const notifyWrap = $('[data-notify-wrap]', pdp);
    const notifyText = $('[data-notify-text]', pdp);
    const notifyTags = $('[data-notify-tags]', pdp);
    const hint = $('[data-size-hint]', pdp);
    const low = $('[data-low-stock]', pdp);

    const initial = variants.find(v => String(v.id) === pdp.dataset.selected);
    if (ci > -1) state.color = initial ? initial.options[ci] : ($('[data-option="color"] .ft-color', pdp)?.dataset.value || null);
    if (si > -1) state.size = single ? variants[0].options[si] : (pdp.dataset.preselect === 'true' && initial ? initial.options[si] : null);
    if (initial) initial.options.forEach((o, i) => { if (i !== ci && i !== si) state.other[i] = o; });

    const matches = (v, size) => (ci < 0 || v.options[ci] === state.color) && (si < 0 || v.options[si] === size) &&
      Object.entries(state.other).every(([i, o]) => v.options[i] === o);
    const current = () => (single ? variants.find(v => matches(v, si < 0 ? null : v.options[si])) : variants.find(v => matches(v, state.size)));

    function sync(fromColor) {
      $('[data-color-name]', pdp) && ($('[data-color-name]', pdp).textContent = state.color || '');
      $$('[data-option="color"] .ft-color', pdp).forEach(b => {
        const on = b.dataset.value === state.color;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      $$('[data-option="size"] .ft-size', pdp).forEach(b => {
        const v = variants.find(x => matches(x, b.dataset.value));
        const sold = !v || !v.available;
        const on = b.dataset.value === state.size;
        b.classList.toggle('is-soldout', sold);
        b.setAttribute('aria-label', b.dataset.value + (sold ? `, ${T.soldOutNotify || 'sold out, notify me'}` : ''));
        b.setAttribute('aria-checked', String(on));
      });
      const sizeRadios = $$('[data-option="size"] .ft-size', pdp);
      sizeRadios.forEach((b, i) => { b.tabIndex = (state.size ? b.dataset.value === state.size : i === 0) ? 0 : -1; });

      const v = (single || state.size) ? current() : null;
      const pickEl = $('[data-sticky-pick]');
      if (pickEl) {
        pickEl.textContent = '';
        if (state.color) pickEl.append(state.color);
        if (si > -1 && !single) {
          if (state.color) pickEl.append(' · ');
          if (state.size) pickEl.append((T.sizeWord || 'Size') + ' ' + state.size);
          else { const m = document.createElement('span'); m.className = 'is-missing'; m.textContent = T.pickYourSize || 'Pick your size'; pickEl.append(m); }
        }
      }
      const soldOut = !productAvailable || (v ? !v.available : false);
      const label = soldOut ? (T.notifyMe || 'Notify me') : (!single && !state.size) ? (T.pickSize || 'Pick a size') : (T.addToCart || 'Add to cart');
      atcBtns.forEach(b => { $('[data-label]', b).textContent = label; b.classList.toggle('is-notify', soldOut); });
      if (mainAtc) mainAtc.hidden = soldOut;
      const inStock = $('[data-in-stock]', pdp); if (inStock) inStock.hidden = soldOut;
      // Express checkout (Shop Pay) buys the variant in the form, so it waits for a size.
      const express = $('[data-express]', pdp); if (express) express.hidden = soldOut || (!single && !state.size);
      if (notifyWrap) {
        notifyWrap.hidden = !soldOut;
        if (soldOut && notifyText) notifyText.textContent = !productAvailable || !state.size || single
          ? (T.soldOutAll || 'Sold out in every size. Leave your email and we\'ll tell you when it\'s back.')
          : (T.soldOutSize || '{size} is sold out. Leave your email and we\'ll tell you when it\'s back.').replace('{size}', state.size);
      }
      if (v) {
        idInput.value = v.id;
        if (notifyTags) notifyTags.value = `restock,restock:${v.id}`;
        $$('[data-price]').forEach(p => p.textContent = v.price);
        $$('[data-price-full]').forEach(p => { p.innerHTML = v.priceHtml || v.price; });
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
        if (fromColor && v.media) showMedia(v.media);
        if (low) { low.hidden = !(v.low && v.available); if (v.low) low.textContent = (T.lowStock || 'Only {n} left in this size.').replace('{n}', v.low); }
      } else if (fromColor && ci > -1) {
        const any = variants.find(x => x.options[ci] === state.color && x.media); if (any) showMedia(any.media);
        if (low) low.hidden = true;
      }
    }

    function radioKeys(group, onPick) {
      group?.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(e.key)) return;
        const items = $$('[role="radio"]', group); const i = items.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault();
        const n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length];
        n.focus(); onPick(n);
      });
    }
    const pickColor = (b) => { state.color = b.dataset.value; sync(true); };
    const pickSize = (b) => { state.size = b.dataset.value; if (hint) hint.hidden = true; sync(false); };
    $$('[data-option="color"] .ft-color', pdp).forEach(b => b.addEventListener('click', () => pickColor(b)));
    $$('[data-option="size"] .ft-size', pdp).forEach(b => b.addEventListener('click', () => pickSize(b)));
    radioKeys($('[data-option="color"]', pdp), pickColor);
    radioKeys($('[data-option="size"]', pdp), pickSize);

    function askSize(b) {
      if (hint) { hint.hidden = false; }
      const sizes = $('[data-option="size"]', pdp);
      if (b.closest('.ft-sticky-atc') && sizes) window.scrollTo({ top: sizes.getBoundingClientRect().top + scrollY - 160, behavior: reducedMotion ? 'auto' : 'smooth' });
      $('[data-option="size"] .ft-size', pdp)?.focus({ preventScroll: !b.closest('.ft-sticky-atc') ? false : true });
    }
    atcBtns.forEach(b => b.addEventListener('click', (e) => {
      e.preventDefault();
      if (!productAvailable) { focusNotify(); return; }
      if (!single && !state.size) { askSize(b); return; }
      const v = current(); if (!v) return;
      if (!v.available) { focusNotify(); return; }
      addToCart(v.id, 1, b);
    }));

    /* Bundle tiers (snippets/bundle-tiers.liquid, assets/bundle-tiers.js). With a set card selected, the kit adds the
       whole set when the main Add to cart button is clicked. This runs first (capture, registered before the kit's
       deferred script): a size still has to be picked, and the sticky bar's button hands over to the main one. */
    const bundleSet = () => { const bt = $('bundle-tiers', pdp); return !!(bt && bt.qty > 1); };
    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-atc]');
      if (!b || !productAvailable || !bundleSet()) return;
      if (!single && !state.size) { e.preventDefault(); e.stopImmediatePropagation(); askSize(b); return; }
      if (b !== mainAtc && mainAtc) { e.preventDefault(); e.stopImmediatePropagation(); mainAtc.click(); }
    }, true);
    window.BundleTiers = window.BundleTiers || {};
    window.BundleTiers.onAdded = async () => { await refreshCart(); openCart(mainAtc); };
    // The sticky bar shows the same label as the main button ("Add 3 to cart" while a set is selected).
    const mainLabel = mainAtc && $('[data-label]', mainAtc);
    if (mainLabel && 'MutationObserver' in window) {
      new MutationObserver(() => {
        $$('.ft-sticky-atc [data-label]').forEach(l => { if (l.textContent !== mainLabel.textContent) l.textContent = mainLabel.textContent; });
      }).observe(mainLabel, { childList: true, characterData: true, subtree: true });
    }
    function focusNotify() {
      if (!notifyWrap) return;
      window.scrollTo({ top: notifyWrap.getBoundingClientRect().top + scrollY - 140, behavior: reducedMotion ? 'auto' : 'smooth' });
      $('input[type="email"]', notifyWrap)?.focus({ preventScroll: true });
    }
    // Without JS the form posts to /cart/add; with JS the ATC button handles it.
    $('[data-product-form]', pdp)?.addEventListener('submit', (e) => e.preventDefault());

    /* gallery */
    const mains = $$('[data-main-media]', pdp);
    const thumbs = $$('.ft-pdp__thumb', pdp);
    let current_i = Math.max(0, mains.findIndex(m => !m.hidden));
    function showIndex(i) {
      current_i = i;
      mains.forEach((m, k) => m.hidden = k !== i);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
      const slide = $$('.ft-pdp__slide', pdp)[i];
      const slider = $('.ft-pdp__slider', pdp);
      if (slide && slider && getComputedStyle(slider).display !== 'none') slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft - 16, behavior: reducedMotion ? 'auto' : 'smooth' });
      const zm = $('#ft-zoom'); if (zm && !zm.hidden) setZoom(i);
    }
    function showMedia(mediaId) {
      const i = mains.findIndex(m => m.dataset.mediaId === String(mediaId));
      if (i > -1) showIndex(i);
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => showIndex(i)));

    const zoom = $('#ft-zoom');
    function setZoom(i) {
      current_i = i;
      const img = $('[data-zoom-img]', zoom); const src = mains[i] && mains[i].dataset.zoom;
      if (img && src && img.dataset.src !== src) {
        // Show the already-loaded gallery image straight away, then swap in the large one.
        const low = mains[i].currentSrc || mains[i].src;
        img.dataset.src = src;
        if (low) img.src = low;
        const hi = new Image();
        hi.onload = () => { if (img.dataset.src === src) img.src = src; };
        hi.src = src;
      }
      if (img) { img.alt = mains[i].dataset.alt || ''; img.style.width = img.style.height = ''; }
      const stage = $('.ft-zoom__stage', zoom);
      if (stage) { stage.classList.remove('is-zoomed'); stage.scrollTo(0, 0); }
      $$('.ft-zoom__thumb', zoom).forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
      const lbl = $('[data-zoom-label]', zoom); if (lbl) lbl.textContent = mains[i]?.dataset.alt || '';
    }
    $$('[data-zoom-open]', pdp).forEach(b => b.addEventListener('click', () => {
      const i = b.dataset.index !== undefined ? +b.dataset.index : current_i;
      setZoom(i); openDialog(zoom, b);
    }));
    $$('.ft-zoom__thumb', zoom || document.createElement('div')).forEach((t, i) => t.addEventListener('click', () => { setZoom(i); showIndex(i); }));
    $('.ft-zoom__stage', zoom || document.createElement('div'))?.addEventListener('click', (e) => {
      const stage = e.currentTarget; const img = $('[data-zoom-img]', stage);
      if (!img) return;
      if (stage.classList.contains('is-zoomed')) {
        stage.classList.remove('is-zoomed'); img.style.width = img.style.height = ''; stage.scrollTo(0, 0); return;
      }
      // Zoom to 2.5x the fitted size, centred on the point that was clicked.
      const r = stage.getBoundingClientRect();
      const nw = img.naturalWidth || 1, nh = img.naturalHeight || 1;
      const fit = Math.min(r.width / nw, r.height / nh);
      const w = nw * fit * 2.5, h = nh * fit * 2.5;
      const fx = ((e.clientX - r.left) - (r.width - nw * fit) / 2) / (nw * fit);
      const fy = ((e.clientY - r.top) - (r.height - nh * fit) / 2) / (nh * fit);
      img.style.width = w + 'px'; img.style.height = h + 'px';
      stage.classList.add('is-zoomed');
      stage.scrollTo(Math.max(0, Math.min(1, fx)) * w - r.width / 2, Math.max(0, Math.min(1, fy)) * h - r.height / 2);
    });

    $$('[data-open-chart]', pdp).forEach(b => b.addEventListener('click', () => openDialog($('#ft-chart'), b)));

    sync(false);

    /* recently viewed (localStorage, max 4 shown) */
    const key = 'ft_recent'; const handle = pdp.dataset.handle;
    let list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]').filter(h => h !== handle); localStorage.setItem(key, JSON.stringify([handle, ...list].slice(0, 8))); } catch (_) { list = []; }
    const rv = $('[data-recent]');
    if (rv && list.length) {
      Promise.all(list.slice(0, 4).map(h => fetch(`${ROOT}products/${encodeURIComponent(h)}?view=card`).then(r => (r.ok ? r.text() : '')).catch(() => '')))
        .then(cards => { const html = cards.filter(c => c.includes('ft-card')).join(''); if (html) { $('[data-recent-grid]', rv).innerHTML = html; rv.hidden = false; } });
    }
  }

  /* ---------- Kids tees: "How tall are they?" size finder (heights from the kids size chart) ---------- */
  $$('[data-kids-fit]').forEach(box => {
    const sizeBtns = $$('[data-option="size"] .ft-size');
    const rows = $$('#ft-chart tr[data-height]')
      .map(tr => ({ size: tr.dataset.size, h: parseFloat(tr.dataset.height) }))
      .filter(r => r.h && sizeBtns.some(b => b.dataset.value === r.size));
    if (!rows.length) return;
    const range = $('[data-kf-range]', box), out = $('[data-kf-out]', box);
    const result = $('[data-kf-result]', box), over = $('[data-kf-over]', box), sizeEl = $('[data-kf-size]', box), roomEl = $('[data-kf-room]', box);
    let fit = null;
    const unit = () => { try { const u = localStorage.getItem('ft_unit'); if (u === 'cm' || u === 'in') return u; } catch (_) { /* private mode */ } return box.dataset.unit; };
    function update() {
      const cm = +range.value;
      const fmt = (v) => unit() === 'in' ? `${Math.round(v / 2.54)} in` : `${Math.round(v)} cm`;
      out.textContent = fmt(cm);
      fit = rows.find(r => cm <= r.h) || null;
      result.hidden = !fit; over.hidden = !!fit;
      if (fit) {
        sizeEl.textContent = fit.size;
        const room = fit.h - cm, next = rows[rows.indexOf(fit) + 1];
        roomEl.textContent = room > 2 ? box.dataset.room.replace('{max}', fmt(fit.h)).replace('{room}', fmt(room)) : (next ? box.dataset.roomTop : '');
      }
      range.setAttribute('aria-valuetext', out.textContent + (fit ? `, ${fit.size}` : ''));
    }
    range.addEventListener('input', update);
    document.addEventListener('click', (e) => { if (e.target.closest('[data-unit-btn]')) setTimeout(update); });
    $('[data-kf-select]', box).addEventListener('click', () => {
      const b = fit && sizeBtns.find(x => x.dataset.value === fit.size);
      if (b) { b.click(); b.focus(); }
    });
    update();
    box.hidden = false;
  });

  /* ---------- Mood quiz: shuffle answers, tally moods, show + share the result (?mood=…) ---------- */
  $$('[data-quiz]').forEach(quiz => {
    const intro = $('[data-quiz-intro]', quiz);
    const qs = $$('[data-quiz-q]', quiz), results = $$('[data-quiz-result]', quiz);
    const screens = [intro, ...qs, ...results];
    const order = ['sarcastic', 'petty', 'wholesome-ish', 'adulting'];
    let tally = {}, last = null;
    const show = (el) => { screens.forEach(s => s.hidden = s !== el); const f = el.querySelector('button, a'); quiz.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' }); if (f) f.focus({ preventScroll: true }); };
    qs.forEach(q => { const box = $('[data-quiz-answers]', q); [...box.children].sort(() => Math.random() - 0.5).forEach(b => box.appendChild(b)); });
    const showResult = (mood) => {
      const r = results.find(x => x.dataset.quizResult === mood); if (!r) return false;
      show(r); const u = new URL(location.href); u.searchParams.set('mood', mood); history.replaceState(history.state, '', u); return true;
    };
    $('[data-quiz-start]', quiz)?.addEventListener('click', () => { tally = {}; last = null; if (qs[0]) show(qs[0]); });
    qs.forEach((q, i) => q.addEventListener('click', (e) => {
      const a = e.target.closest('[data-mood]'); if (!a) return;
      tally[a.dataset.mood] = (tally[a.dataset.mood] || 0) + 1; last = a.dataset.mood;
      if (qs[i + 1]) { show(qs[i + 1]); return; }
      const best = Math.max(...Object.values(tally));
      const tied = order.filter(m => tally[m] === best);
      showResult(tied.includes(last) ? last : tied[0]);
    }));
    quiz.addEventListener('click', async (e) => {
      if (e.target.closest('[data-quiz-restart]')) {
        const u = new URL(location.href); u.searchParams.delete('mood'); history.replaceState(history.state, '', u); show(intro); return;
      }
      const sh = e.target.closest('[data-quiz-share]'); if (!sh) return;
      const url = location.href, text = sh.dataset.shareText;
      if (navigator.share) { try { await navigator.share({ text, url }); } catch (_) { /* cancelled */ } return; }
      try { await navigator.clipboard.writeText(`${text} ${url}`); } catch (_) { /* no clipboard */ }
      const c = $('[data-quiz-copied]', sh.closest('[data-quiz-result]')); if (c) { c.hidden = false; setTimeout(() => { c.hidden = true; }, 3000); }
    });
    const pre = new URLSearchParams(location.search).get('mood');
    if (pre) showResult(pre.toLowerCase());
  });

  /* ---------- Product page add-on: size picker enables Add; follows the size picked above ---------- */
  $$('[data-addon]').forEach(box => {
    const sel = $('[data-addon-select]', box), btn = $('[data-addon-btn]', box);
    if (!sel || !btn) return;
    let touched = false;
    const apply = () => { btn.dataset.variant = sel.value; btn.disabled = !sel.value; };
    sel.addEventListener('change', () => { touched = true; apply(); });
    document.addEventListener('click', (e) => {
      const s = e.target.closest('[data-option="size"] .ft-size'); if (!s || touched) return;
      const opt = [...sel.options].find(o => o.dataset.size === s.dataset.value && !o.disabled);
      if (opt) { sel.value = opt.value; apply(); }
    });
  });

  /* ---------- Caps: anatomy hotspots + hidden under-visor message ---------- */
  $$('[data-cap-anatomy]').forEach(root => {
    const pick = (i) => {
      $$('[data-cap-hot]', root).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.capHot === i)));
      $$('[data-cap-item]', root).forEach(li => li.classList.toggle('is-active', li.dataset.capItem === i));
    };
    root.addEventListener('click', (e) => {
      const hot = e.target.closest('[data-cap-hot]'); if (hot) pick(hot.dataset.capHot);
      const sec = e.target.closest('[data-cap-secret]');
      if (sec) { const open = sec.getAttribute('aria-expanded') !== 'true'; sec.setAttribute('aria-expanded', String(open)); }
    });
  });

  /* ---------- Balaclava hoodie: social battery switch ---------- */
  $$('[data-bala]').forEach(root => {
    root.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-bala-mode]');
      if (opt) {
        const m = opt.dataset.balaMode;
        $$('[data-bala-mode]', root).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.balaMode === m)));
        $$('[data-bala-panel]', root).forEach(p => { p.hidden = p.dataset.balaPanel !== m; });
        $$('[data-bala-shot]', root).forEach(s => s.classList.toggle('is-active', s.dataset.balaShot === m));
      }
      if (e.target.closest('[data-bala-chart]')) { const b = $('[data-open-chart]'); if (b) b.click(); }
    });
  });

  /* ---------- Size guide on the page: linked to the size picker ---------- */
  $$('[data-size-guide]').forEach(root => {
    const sizeBtn = (v) => $$('[data-option="size"] .ft-size').find(b => b.dataset.value === v);
    const rows = $$('tbody tr', root).filter(tr => $('th', tr) && sizeBtn($('th', tr).textContent.trim()));
    const chosen = $('[data-sg-chosen]', root), hint = $('[data-sg-hint]', root), out = $('[data-sg-size]', root);
    if (!rows.length) { if (hint) hint.hidden = true; return; }
    rows.forEach(tr => {
      tr.classList.add('is-pickable'); tr.tabIndex = 0; tr.title = 'Pick ' + $('th', tr).textContent.trim();
    });
    const refresh = () => {
      const on = $('[data-option="size"] .ft-size[aria-checked="true"]');
      const v = on ? on.dataset.value : null;
      rows.forEach(tr => { const hit = $('th', tr).textContent.trim() === v; tr.classList.toggle('is-picked', hit); tr.setAttribute('aria-current', hit ? 'true' : 'false'); });
      if (chosen) chosen.hidden = !v; if (hint) hint.hidden = !!v; if (out) out.textContent = v || '';
    };
    const pick = (tr) => { const b = sizeBtn($('th', tr).textContent.trim()); if (b) { b.click(); setTimeout(refresh); } };
    root.addEventListener('click', (e) => {
      const tr = e.target.closest('tr.is-pickable'); if (tr) pick(tr);
      if (e.target.closest('[data-sg-add]')) { const atc = $('[data-atc-main]'); if (atc && !atc.hidden) atc.click(); }
    });
    root.addEventListener('keydown', (e) => { const tr = e.target.closest('tr.is-pickable'); if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(tr); } });
    document.addEventListener('click', (e) => { if (e.target.closest('[data-option="size"] .ft-size, [data-option="color"] .ft-color')) setTimeout(refresh); });
    refresh();
  });

  /* ---------- Backless hoodie: front/back reveal, colour cards, size chart link ---------- */
  $$('[data-bk]').forEach(root => {
    const rv = $('[data-bk-reveal]', root); const range = $('[data-bk-range]', root);
    if (rv && range) {
      const set = (v) => { v = Math.max(0, Math.min(100, v)); rv.style.setProperty('--pos', v + '%'); range.value = Math.round(v); };
      const at = (e) => { const r = rv.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); };
      let drag = false;
      range.addEventListener('input', () => set(+range.value));
      rv.addEventListener('pointerdown', (e) => { drag = true; at(e); });
      window.addEventListener('pointermove', (e) => { if (drag) at(e); });
      ['pointerup', 'pointercancel'].forEach(t => window.addEventListener(t, () => { drag = false; }));
      rv.addEventListener('click', () => range.focus({ preventScroll: true }));
      // A one-time nudge the first time it comes into view, so it reads as something to drag.
      if (!reducedMotion && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => {
          if (!en[0].isIntersecting) return; io.disconnect();
          const tween = (from, to, ms, done) => {
            const t0 = performance.now();
            const f = (t) => {
              if (drag) return;
              const p = Math.min(1, (t - t0) / ms); const ease = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
              set(from + (to - from) * ease);
              if (p < 1) requestAnimationFrame(f); else if (done) done();
            };
            requestAnimationFrame(f);
          };
          setTimeout(() => tween(50, 72, 500, () => tween(72, 28, 700, () => tween(28, 50, 500))), 400);
        }, { threshold: 0.6 });
        io.observe(rv);
      }
    }
    root.addEventListener('click', (e) => {
      const c = e.target.closest('[data-bk-color]');
      if (c) {
        const sw = $$('[data-option="color"] .ft-color').find(b => b.dataset.value === c.dataset.bkColor);
        if (sw) {
          sw.click();
          const blk = sw.closest('.ft-pdp__block') || sw;
          window.scrollTo({ top: blk.getBoundingClientRect().top + scrollY - 120, behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      }
      if (e.target.closest('[data-bk-chart]')) { const b = $('[data-open-chart]'); if (b) b.click(); }
    });
  });

  /* ---------- Customer photos: flip cards + arrows ---------- */
  $$('[data-wild]').forEach(root => {
    const track = $('[data-wild-track]', root);
    root.addEventListener('click', (e) => {
      const flip = e.target.closest('[data-wild-flip]');
      if (flip) {
        const card = flip.closest('[data-wild-card]'); const on = !card.classList.contains('is-flipped');
        card.classList.toggle('is-flipped', on);
        $$('[data-wild-flip]', card).forEach(b => b.setAttribute('aria-expanded', String(on)));
        const target = on ? $('.ft-wild__back [data-wild-flip]', card) : $('.ft-wild__front [data-wild-flip]', card);
        if (target) setTimeout(() => target.focus({ preventScroll: true }), 300);
      }
      const sound = e.target.closest('[data-wild-sound]');
      if (sound) {
        const vid = $('[data-wild-video]', sound.closest('[data-wild-card]')); if (!vid) return;
        const on = sound.getAttribute('aria-pressed') !== 'true';
        // One card with sound at a time.
        $$('[data-wild-sound][aria-pressed="true"]', root).forEach(b => { if (b !== sound) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', T.videoSoundOn || 'Play with sound'); const o = $('[data-wild-video]', b.closest('[data-wild-card]')); if (o) o.muted = true; } });
        sound.setAttribute('aria-pressed', String(on));
        sound.setAttribute('aria-label', on ? (T.videoSoundOff || 'Mute') : (T.videoSoundOn || 'Play with sound'));
        if (!vid.src) vid.src = vid.dataset.src;
        vid.muted = !on;
        if (on) { vid.currentTime = 0; vid.play().catch(() => {}); }
      }
      const dir = e.target.closest('[data-wild-next]') ? 1 : e.target.closest('[data-wild-prev]') ? -1 : 0;
      if (dir && track) track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    });

    // Videos load and play (muted) only while their card is on screen; the photo shows until the first frame plays.
    const vids = $$('[data-wild-video]', root);
    vids.forEach(v => v.addEventListener('playing', () => v.classList.add('is-playing')));
    if (vids.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach(({ target: v, isIntersecting }) => {
        if (isIntersecting) {
          if (reducedMotion && v.muted) return;
          if (!v.src) v.src = v.dataset.src;
          v.play().catch(() => {});
        } else if (v.src) {
          v.pause();
          // Sound goes off when the card leaves the screen, so it never starts playing aloud on its own.
          if (!v.muted) { v.muted = true; const sb = $('[data-wild-sound]', v.closest('[data-wild-card]')); if (sb) { sb.setAttribute('aria-pressed', 'false'); sb.setAttribute('aria-label', T.videoSoundOn || 'Play with sound'); } }
        }
      }), { threshold: 0.6 });
      vids.forEach(v => io.observe(v));
    }
  });

  /* ---------- Wear it with (product recommendations) ---------- */
  const rec = $('[data-recommendations]');
  if (rec && rec.dataset.url) loadRecs(rec);
  async function loadRecs(el) {
    const type = (el.dataset.productType || '').toLowerCase();
    const fetchCards = async (intent) => {
      const u = new URL(el.dataset.url, location.origin); u.searchParams.set('intent', intent);
      const r = await fetch(u); if (!r.ok) return [];
      return $$('.ft-card', parse(await r.text()));
    };
    let cards = (await fetchCards('complementary').catch(() => [])).filter(c => (c.dataset.productType || '').toLowerCase() !== type && c.dataset.available === 'true');
    if (cards.length < 4) {
      const more = (await fetchCards('related').catch(() => [])).filter(c => (c.dataset.productType || '').toLowerCase() !== type && c.dataset.available === 'true');
      const seen = new Set(cards.map(c => c.dataset.productId));
      more.forEach(c => { if (!seen.has(c.dataset.productId)) { cards.push(c); seen.add(c.dataset.productId); } });
    }
    cards = cards.slice(0, 4);
    if (!cards.length) return;
    const grid = $('[data-rec-grid]', el); grid.innerHTML = ''; cards.forEach(c => grid.appendChild(document.importNode(c, true)));
    el.hidden = false;
  }

  /* ---------- Collection: filter panels, section re-render, load more ---------- */
  const COL = '[data-collection]';
  function bindCollection(root) {
    $$('[data-filter-toggle]', root).forEach(b => b.addEventListener('click', () => {
      const id = b.dataset.filterToggle;
      const panel = $(`[data-filter-panel="${id}"]`, root);
      const willOpen = panel.hidden;
      $$('[data-filter-panel]', root).forEach(p => p.hidden = true);
      $$('[data-filter-toggle]', root).forEach(x => x.setAttribute('aria-expanded', 'false'));
      panel.hidden = !willOpen; b.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) $('a,button', $('.ft-filter-opts', panel))?.focus();
    }));
    $$('[data-filter-close]', root).forEach(b => b.addEventListener('click', () => {
      const p = b.closest('[data-filter-panel]'); p.hidden = true;
      const t = $(`[data-filter-toggle="${p.dataset.filterPanel}"]`, root); t?.setAttribute('aria-expanded', 'false'); t?.focus();
    }));
    $('[data-sort]', root)?.addEventListener('change', (e) => {
      const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page');
      renderCollection(u.toString());
    });
    const more = $('[data-load-more]', root);
    more?.addEventListener('click', async (e) => {
      e.preventDefault();
      if (more.hasAttribute('aria-busy')) return;
      more.setAttribute('data-loading', ''); more.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(withSection(more.dataset.next, root.dataset.sectionId));
        const d = parse(await r.text());
        const grid = $('[data-grid-b]', root);
        $$('[data-grid-a] > .ft-card, [data-grid-b] > .ft-card', d).forEach(c => grid.appendChild(document.importNode(c, true)));
        grid.hidden = false;
        const shown = $('[data-shown]', d); if (shown) $('[data-shown]', root).textContent = shown.textContent;
        const nm = $('[data-load-more]', d);
        if (nm) { more.dataset.next = nm.dataset.next; more.href = nm.dataset.next; more.removeAttribute('data-loading'); more.removeAttribute('aria-busy'); } else more.remove();
      } catch (_) { location.href = more.dataset.next; }
    });
  }
  async function renderCollection(url, push = true) {
    const root = $(COL); if (!root) { location.href = url; return; }
    const openPanel = $('[data-filter-panel]:not([hidden])', root)?.dataset.filterPanel;
    root.classList.add('is-loading-section');
    try {
      const r = await fetch(withSection(url, root.dataset.sectionId));
      const d = parse(await r.text());
      const next = $(COL, d); if (!next) throw new Error('no section');
      root.innerHTML = next.innerHTML;
      root.classList.remove('is-loading-section');
      if (push) history.pushState({ ftCollection: true }, '', url);
      bindCollection(root);
      if (openPanel) { const p = $(`[data-filter-panel="${openPanel}"]`, root); const t = $(`[data-filter-toggle="${openPanel}"]`, root); if (p && t) { p.hidden = false; t.setAttribute('aria-expanded', 'true'); } }
    } catch (_) { location.href = url; }
  }
  const colRoot = $(COL);
  if (colRoot) {
    bindCollection(colRoot);
    colRoot.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-filter-link]'); if (!a || e.metaKey || e.ctrlKey) return;
      e.preventDefault(); renderCollection(a.href);
    });
    window.addEventListener('popstate', () => renderCollection(location.href, false));
  }

  /* ---------- Footer: "Cookie preferences" reopens Shopify's consent banner when it's enabled ---------- */
  const cookieBtn = $('[data-cookie-prefs]');
  if (cookieBtn) {
    const showCookieBtn = () => { if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') cookieBtn.hidden = false; };
    showCookieBtn(); window.addEventListener('load', () => { showCookieBtn(); setTimeout(showCookieBtn, 2000); });
    cookieBtn.addEventListener('click', () => window.privacyBanner?.showPreferences());
  }

  /* ---------- Tabs (homepage category tabs): click or arrow keys switch the panel ---------- */
  $$('[data-tabs]').forEach(root => {
    const tabs = $$('[data-tab]', root); const panels = $$('[data-tabpanel]', root);
    const show = (i, focus) => {
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach((p, k) => { p.hidden = k !== i; });
      if (focus) tabs[i].focus();
      tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(i, false));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (e.key === 'Home') { e.preventDefault(); show(0, true); }
        else if (e.key === 'End') { e.preventDefault(); show(tabs.length - 1, true); }
        else if (d) { e.preventDefault(); show((i + d + tabs.length) % tabs.length, true); }
      });
    });
  });
})();
